var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-container"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.$store.state.app[_vm.$store.state.app.theme].navlogo}})])}
var staticRenderFns = []

export { render, staticRenderFns }